module.exports = __webpack_public_path__ + "img/customer-icon-15.77f347a2.png";